import React, { useEffect, useState } from "react";
import emptyCpayImage from "../../../img/cpay-svg/empty.svg";
import emptyNFGImage from "../../../img/nfgpay-svg/empty-nfg.svg";
import emptyFinvaroImage from "../../../img/finvaro/empty-finvaro.svg";
import emptyClarniumImage from "../../../img/clarnium/empty-clarnium.svg";
import emptyInexImage from "../../../img/inex/empty-inex.svg";
import emptyInstaImage from '../../../img/instaXchange/empty-insta.svg';
import { identity } from "../../../utils/getIdentity";
import { Row, Col, Input, Pagination } from "antd";
import { ReactComponent as Copy } from "../../../img/default-svg/copyActivity.svg";
import { ReactComponent as CopyInex } from "../../../img/inex/copy-blue-inex.svg";
import { ReactComponent as CopyInsta } from "../../../img/instaXchange/copy-blue-insta.svg";
import { ReactComponent as External } from "../../../img/default-svg/externalLink.svg";
import { ReactComponent as ExternalInex } from "../../../img/inex/externalLink.svg";
import { ReactComponent as ExternalInsta } from "../../../img/instaXchange/externalLink.svg";
import CopyWrapper from "../../CopyWrapper";
import { truncate } from "../../../utils/truncateFunction";
import { useLocation } from "react-router-dom";
import resetCpayIcon from "../../../img/cpay-svg/reset.svg";
import resetNfgIcon from "../../../img/nfgpay-svg/reset-nfg.svg";
import resetFinvaroIcon from "../../../img/finvaro/reset-finvaro.svg";
import resetClarniumIcon from "../../../img/clarnium/reset-clarnium.svg";
import resetInexIcon from "../../../img/inex/reset-inex.svg";
import resetInstaIcon from "../../../img/instaXchange/reset-insta.svg";
import resetCoineraIcon from "../../../img/coinera/reset-coinera.svg";
import TokenIcon from '../../../components/TokenIcon';
import { useTranslation } from "react-i18next";

const resetIcon = {
  cpay: resetCpayIcon,
  nfg: resetNfgIcon,
  finvaro: resetFinvaroIcon,
  clarnium: resetClarniumIcon,
  inex: resetInexIcon,
  insta: resetInstaIcon,
  coinera: resetCoineraIcon
};

const checkoutsNoDataSVG = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage
};

const copyIcon = {
  cpay: <Copy />,
  nfg: <Copy />,
  finvaro: <Copy />,
  clarnium: <Copy />,
  inex: <CopyInex />,
  insta: <CopyInsta />
}

const externalIcon = {
  cpay: <External />,
  nfg: <External />,
  finvaro: <External />,
  clarnium: <External />,
  inex: <ExternalInex />,
  insta: <ExternalInsta />
}

const ActivitiesList = ({ activities, getActivities, merchantId, typeNetwork }) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const planId = urlParams.get('planId');
  const { page, pages, countItem, data } = activities;

  const [search, setSearch] = useState(null);

  const { t } = useTranslation();

  const handleGetActivities = async (currentPage = 1) => {
    await getActivities(merchantId, {
      page: currentPage,
      typeNetwork: typeNetwork,
      planId: planId,
      order: 'DESC',
      search: search
    });
  };

  const resetSearch = async () => {
    setSearch(null);
    await getActivities(merchantId, {
      typeNetwork: typeNetwork,
      planId: planId,
      order: 'DESC',
      search: null
    });
  };

  useEffect(() => {
    if (merchantId && typeNetwork && planId) {
      handleGetActivities()
    }
  }, [merchantId, typeNetwork, planId]);

  const periodType = {
    0: t('admin.hourly'),
    1: t('admin.daily'),
    2: t('admin.weekly'),
    3: t('admin.monthly'),
    4: t('admin.yearly'),
  };

  const activityType = {
    "RECURRING_PAYMENT_NEW_SUB": t('admin.new_subscription'),
    "RECURRING_PAYMENT_RENEWAL_SUB": t('admin.renewal_subscription'),
    "RECURRING_PAYMENT_CANCEL_SUB": t('admin.cancel_subscription'),
  }

  return (
    <div className="subscriptions">
      <div className="subscriptions__title">
        <div>{t('activities')}</div>
        <div>
          <Input.Search
            name="search"
            placeholder="Search..."
            onSearch={() => handleGetActivities()}
            className="checkouts-header__search-field"
            onChange={e => setSearch(e.target.value)}
            value={search}
            addonAfter={
              <span onClick={resetSearch} className="checkouts-header__reset-button">
                <img src={resetIcon[identity]} alt="Reset" />
              </span>
            }
          />
        </div>
      </div>
      {!activities?.data?.length ? (
        <div className="checkouts-list__empty">
          <div className="checkouts-list__empty-text">{t('plans.noAct')}</div>
          <img src={checkoutsNoDataSVG[identity]} alt="" />
        </div>
      ) : (
        <div className="activities__wrapper">
          <Row className="activities">
            <Col className="activities__titleCenter" span={3}>
              {t('plans.period')}
            </Col>
            <Col className="activities__titleCenter" span={5}>
              {t('plans.type')}
            </Col>
            <Col className="activities__titleCenter" span={4}>
              {t('plans.amount')}
            </Col>
            <Col className="activities__titleCenter" span={7}>
              {t('plans.last')}
            </Col>
            <Col className="activities__titleCenter" span={5}>
              {t('plans.actOwner')}
            </Col>
          </Row>
          <div>
            {activities?.data?.map((item) => (
              <Row className={`activities__rows activities__rows-${identity}`}>
                <Col className="activities__center--act" span={3}>
                  {periodType[item?.periodType] || '-'}
                </Col>
                <Col className="activities__center--act" span={5}>
                  {activityType[item?.type] || '-'}
                </Col>
                <Col className="activities__center--act" span={4}>
                  {item?.amountRecurring || 0}
                  {' '}
                  {item?.currencyName}
                </Col>
                <Col className="activities__center--act" span={7}>
                  {item?.hashTx ? (
                    <div className="activities__hash">
                      <div className="activities__hash--link">{truncate(item?.hashTx, 20, '..')}</div>
                      <div className="activities__hash--icons">
                        <CopyWrapper copyContent={item?.hashTx}>
                          {copyIcon[identity]}
                        </CopyWrapper>
                        <a href={item?.explorerUrl} target="_blank">
                          {externalIcon[identity]}
                        </a>
                      </div>
                    </div>
                  ) : '-'}
                </Col>
                <Col className="activities__center--act" span={5}>
                  {item?.owner ? (
                    <div className="activities__hash">
                      <TokenIcon tokenName={item?.nodeType} />
                      <div className="activities__hash--link">{truncate(item?.owner, 14, '..')}</div>
                      <div className="activities__hash--icons">
                        <CopyWrapper copyContent={item?.owner}>
                          {copyIcon[identity]}
                        </CopyWrapper>
                      </div>
                    </div>
                  ) : '-'}
                </Col>
              </Row>
            ))}
          </div>
        </div>
      )}

      <div className="activities__pagination">
        {pages > 1 && (
          <Pagination
            current={page}
            total={countItem}
            pageSize={10}
            showTotal={false}
            showSizeChanger={false}
            size="small"
            onChange={page => handleGetActivities(page)}
          />
        )}
      </div>
    </div>
  )
};

export default ActivitiesList;